import { useTranslation } from "react-i18next";
import { ProductIcon } from "@/components/ProductIcon";
import type { QuestionContext } from "@/engine/wizardUi";

export function QuestionContextBanner({ context }: { context: QuestionContext }) {
  const { t } = useTranslation();

  if (context.kind === "dual") {
    return (
      <div className="flex flex-col items-center mb-2 gap-2">
        <div className="flex items-center gap-3">
          {context.products.map((product) => (
            <div
              key={product.id}
              className="w-12 h-12 rounded-2xl bg-ink-5 border border-ink-10 flex items-center justify-center"
            >
              <ProductIcon name={product.id} className="w-8 h-8 rounded-lg" />
            </div>
          ))}
        </div>
        <span className="text-xs font-medium text-muted-foreground tracking-wide">
          {t("wizard.rwAndMindView")}
        </span>
      </div>
    );
  }

  const product = context.products[0];
  return (
    <div className="flex flex-col items-center mb-2 gap-2">
      <div className="w-14 h-14 rounded-2xl bg-ink-5 border border-ink-10 flex items-center justify-center">
        <ProductIcon name={product.id} className="w-9 h-9 rounded-lg" />
      </div>
      <span className="text-xs font-medium text-muted-foreground tracking-wide">
        {product.label}
      </span>
    </div>
  );
}
